import React from 'react';
import PropTypes from 'prop-types';

const Background = ({ 
  image, 
  overlay = false, 
  position = '50%', 
  className = '',
  ...rest 
}) => {
  const backgroundStyle = {
    backgroundImage: image ? `url(${image})` : 'none',
    backgroundPosition: position,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    ...rest.style
  };

  return (
    <div
      className={`bg-holder ${className}`}
      style={backgroundStyle}
      {...rest}
    >
      {overlay && (
        <div 
          className="bg-overlay" 
          style={{ 
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }}
        />
      )}
    </div>
  );
};

Background.propTypes = {
  image: PropTypes.string,
  overlay: PropTypes.bool,
  position: PropTypes.string,
  className: PropTypes.string
};

export default Background;
